// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=none"
// @generated from file user.proto (package puppy.proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "./buf/validate/validate_pb";
import type { EmptySchema } from "./google/protobuf/empty_pb";
import { file_google_protobuf_empty } from "./google/protobuf/empty_pb";
import type { EmptyResponseSchema, UserType } from "./basic_pb";
import { file_basic } from "./basic_pb";
import type { UserRoleAccess } from "./permission_pb";
import { file_permission } from "./permission_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user.proto.
 */
export const file_user: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_google_protobuf_empty, file_basic, file_permission]);

/**
 * 注册请求
 *
 * @generated from message puppy.proto.v1.RegisterRequest
 */
export type RegisterRequest = Message<"puppy.proto.v1.RegisterRequest"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string phone = 3;
   */
  phone: string;

  /**
   * @generated from field: string code = 4;
   */
  code: string;
};

/**
 * Describes the message puppy.proto.v1.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_user, 0);

/**
 * 登录请求
 *
 * @generated from message puppy.proto.v1.LoginRequest
 */
export type LoginRequest = Message<"puppy.proto.v1.LoginRequest"> & {
  /**
   * 主账号用户名或子账号用户名
   *
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * 密码
   *
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * 可选：租户 ID（子用户登录时使用）
   *
   * @generated from field: uint64 tenant_id = 3;
   */
  tenantId: bigint;

  /**
   * 可选：任务邀请令牌
   *
   * @generated from field: optional string invite_token = 4;
   */
  inviteToken?: string | undefined;
};

/**
 * Describes the message puppy.proto.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_user, 1);

/**
 * 登录响应
 *
 * @generated from message puppy.proto.v1.LoginResponse
 */
export type LoginResponse = Message<"puppy.proto.v1.LoginResponse"> & {
  /**
   * JWT 访问令牌；需要 2FA 时此令牌仅用于 2FA 验证流程
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * 当前登录用户信息（主用户或子用户）
   *
   * @generated from field: puppy.proto.v1.User user = 3;
   */
  user?: User | undefined;
};

/**
 * Describes the message puppy.proto.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_user, 2);

/**
 * 登出请求
 * 使用绑定到 HttpOnly Cookie 的 refresh_token 登出。
 *
 * @generated from message puppy.proto.v1.LogoutRequest
 */
export type LogoutRequest = Message<"puppy.proto.v1.LogoutRequest"> & {
};

/**
 * Describes the message puppy.proto.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_user, 3);

/**
 * 登出响应
 *
 * @generated from message puppy.proto.v1.LogoutResponse
 */
export type LogoutResponse = Message<"puppy.proto.v1.LogoutResponse"> & {
};

/**
 * Describes the message puppy.proto.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_user, 4);

/**
 * 找回密码请求
 *
 * @generated from message puppy.proto.v1.ResetPasswordRequest
 */
export type ResetPasswordRequest = Message<"puppy.proto.v1.ResetPasswordRequest"> & {
  /**
   * 邮箱（与 phone 二选一）
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * 手机号（与 email 二选一）
   *
   * @generated from field: string phone = 2;
   */
  phone: string;

  /**
   * 验证码
   *
   * @generated from field: string code = 3;
   */
  code: string;

  /**
   * @generated from field: string new_password = 4;
   */
  newPassword: string;
};

/**
 * Describes the message puppy.proto.v1.ResetPasswordRequest.
 * Use `create(ResetPasswordRequestSchema)` to create a new message.
 */
export const ResetPasswordRequestSchema: GenMessage<ResetPasswordRequest> = /*@__PURE__*/
  messageDesc(file_user, 5);

/**
 * 获取验证码请求
 *
 * @generated from message puppy.proto.v1.GetVerificationCodeRequest
 */
export type GetVerificationCodeRequest = Message<"puppy.proto.v1.GetVerificationCodeRequest"> & {
  /**
   * 邮箱（与 phone 二选一）
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * 手机号（与 email 二选一）
   *
   * @generated from field: string phone = 2;
   */
  phone: string;
};

/**
 * Describes the message puppy.proto.v1.GetVerificationCodeRequest.
 * Use `create(GetVerificationCodeRequestSchema)` to create a new message.
 */
export const GetVerificationCodeRequestSchema: GenMessage<GetVerificationCodeRequest> = /*@__PURE__*/
  messageDesc(file_user, 6);

/**
 * 用户信息
 *
 * @generated from message puppy.proto.v1.User
 */
export type User = Message<"puppy.proto.v1.User"> & {
  /**
   * 用户 ID
   *
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * 用户名
   *
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * 邮箱
   *
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * 手机号
   *
   * @generated from field: string phone = 4;
   */
  phone: string;

  /**
   * 是否已启用 2FA
   *
   * @generated from field: bool is_2fa_enabled = 5;
   */
  is2faEnabled: boolean;

  /**
   * 用户类型（主用户/子用户）
   *
   * @generated from field: puppy.proto.v1.UserType user_type = 6;
   */
  userType: UserType;

  /**
   * 租户 ID
   *
   * @generated from field: uint64 tenant_id = 7;
   */
  tenantId: bigint;

  /**
   * 当前用户的角色与合并后的权限/约束（主要用于子用户 RBAC/ABAC）
   *
   * @generated from field: puppy.proto.v1.UserRoleAccess role_access = 8;
   */
  roleAccess?: UserRoleAccess | undefined;

  /**
   * 显示名
   *
   * @generated from field: string display_name = 9;
   */
  displayName: string;

  /**
   * 头像 URL
   *
   * @generated from field: string avatar_url = 10;
   */
  avatarUrl: string;

  /**
   * 主用户 ID（主用户自身则为当前用户 ID）
   *
   * @generated from field: uint64 main_user_id = 11;
   */
  mainUserId: bigint;

  /**
   * 主用户名称（主账号用户名）
   *
   * @generated from field: string main_username = 12;
   */
  mainUsername: string;
};

/**
 * Describes the message puppy.proto.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_user, 7);

/**
 * 修改显示名请求
 *
 * @generated from message puppy.proto.v1.UpdateDisplayNameRequest
 */
export type UpdateDisplayNameRequest = Message<"puppy.proto.v1.UpdateDisplayNameRequest"> & {
  /**
   * 显示名（会 trim；允许传空以清空）
   *
   * @generated from field: string display_name = 1;
   */
  displayName: string;
};

/**
 * Describes the message puppy.proto.v1.UpdateDisplayNameRequest.
 * Use `create(UpdateDisplayNameRequestSchema)` to create a new message.
 */
export const UpdateDisplayNameRequestSchema: GenMessage<UpdateDisplayNameRequest> = /*@__PURE__*/
  messageDesc(file_user, 8);

/**
 * 修改密码请求
 *
 * @generated from message puppy.proto.v1.ChangePasswordRequest
 */
export type ChangePasswordRequest = Message<"puppy.proto.v1.ChangePasswordRequest"> & {
  /**
   * 旧密码
   *
   * @generated from field: string old_password = 1;
   */
  oldPassword: string;

  /**
   * @generated from field: string new_password = 2;
   */
  newPassword: string;
};

/**
 * Describes the message puppy.proto.v1.ChangePasswordRequest.
 * Use `create(ChangePasswordRequestSchema)` to create a new message.
 */
export const ChangePasswordRequestSchema: GenMessage<ChangePasswordRequest> = /*@__PURE__*/
  messageDesc(file_user, 9);

/**
 * 绑定邮箱请求
 *
 * @generated from message puppy.proto.v1.BindEmailRequest
 */
export type BindEmailRequest = Message<"puppy.proto.v1.BindEmailRequest"> & {
  /**
   * 邮箱
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * 验证码
   *
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message puppy.proto.v1.BindEmailRequest.
 * Use `create(BindEmailRequestSchema)` to create a new message.
 */
export const BindEmailRequestSchema: GenMessage<BindEmailRequest> = /*@__PURE__*/
  messageDesc(file_user, 10);

/**
 * 绑定手机请求
 *
 * @generated from message puppy.proto.v1.BindPhoneRequest
 */
export type BindPhoneRequest = Message<"puppy.proto.v1.BindPhoneRequest"> & {
  /**
   * 手机号
   *
   * @generated from field: string phone = 1;
   */
  phone: string;

  /**
   * 验证码
   *
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message puppy.proto.v1.BindPhoneRequest.
 * Use `create(BindPhoneRequestSchema)` to create a new message.
 */
export const BindPhoneRequestSchema: GenMessage<BindPhoneRequest> = /*@__PURE__*/
  messageDesc(file_user, 11);

/**
 * 用户配额信息
 *
 * @generated from message puppy.proto.v1.QuotaInfo
 */
export type QuotaInfo = Message<"puppy.proto.v1.QuotaInfo"> & {
  /**
   * 总配额（字节）
   *
   * @generated from field: uint64 total_quota = 1;
   */
  totalQuota: bigint;

  /**
   * 已用配额（字节）
   *
   * @generated from field: uint64 used_quota = 2;
   */
  usedQuota: bigint;
};

/**
 * Describes the message puppy.proto.v1.QuotaInfo.
 * Use `create(QuotaInfoSchema)` to create a new message.
 */
export const QuotaInfoSchema: GenMessage<QuotaInfo> = /*@__PURE__*/
  messageDesc(file_user, 12);

/**
 * 用户仪表盘数据
 *
 * @generated from message puppy.proto.v1.UserDashboard
 */
export type UserDashboard = Message<"puppy.proto.v1.UserDashboard"> & {
  /**
   * 配额信息
   *
   * @generated from field: puppy.proto.v1.QuotaInfo quota = 1;
   */
  quota?: QuotaInfo | undefined;

  /**
   * 分享统计
   *
   * @generated from field: puppy.proto.v1.DashboardShareStats shares = 2;
   */
  shares?: DashboardShareStats | undefined;

  /**
   * 主用户的子用户统计（子用户为空）
   *
   * @generated from field: puppy.proto.v1.DashboardSubUserStats sub_users = 3;
   */
  subUsers?: DashboardSubUserStats | undefined;

  /**
   * 文件统计
   *
   * @generated from field: puppy.proto.v1.DashboardFileStats file_stats = 4;
   */
  fileStats?: DashboardFileStats | undefined;
};

/**
 * Describes the message puppy.proto.v1.UserDashboard.
 * Use `create(UserDashboardSchema)` to create a new message.
 */
export const UserDashboardSchema: GenMessage<UserDashboard> = /*@__PURE__*/
  messageDesc(file_user, 13);

/**
 * 仪表盘分享统计
 *
 * @generated from message puppy.proto.v1.DashboardShareStats
 */
export type DashboardShareStats = Message<"puppy.proto.v1.DashboardShareStats"> & {
  /**
   * 总分享数
   *
   * @generated from field: int32 total = 1;
   */
  total: number;

  /**
   * 有效分享数（启用且未过期）
   *
   * @generated from field: int32 active = 2;
   */
  active: number;
};

/**
 * Describes the message puppy.proto.v1.DashboardShareStats.
 * Use `create(DashboardShareStatsSchema)` to create a new message.
 */
export const DashboardShareStatsSchema: GenMessage<DashboardShareStats> = /*@__PURE__*/
  messageDesc(file_user, 14);

/**
 * 仪表盘文件统计
 *
 * @generated from message puppy.proto.v1.DashboardFileStats
 */
export type DashboardFileStats = Message<"puppy.proto.v1.DashboardFileStats"> & {
  /**
   * 文件/文件夹总数（递归统计，包含文件夹占位对象）
   *
   * @generated from field: int32 total_files = 1;
   */
  totalFiles: number;
};

/**
 * Describes the message puppy.proto.v1.DashboardFileStats.
 * Use `create(DashboardFileStatsSchema)` to create a new message.
 */
export const DashboardFileStatsSchema: GenMessage<DashboardFileStats> = /*@__PURE__*/
  messageDesc(file_user, 15);

/**
 * 仪表盘子用户统计（仅主用户）
 *
 * @generated from message puppy.proto.v1.DashboardSubUserStats
 */
export type DashboardSubUserStats = Message<"puppy.proto.v1.DashboardSubUserStats"> & {
  /**
   * 子用户总数
   *
   * @generated from field: int32 total = 1;
   */
  total: number;

  /**
   * 启用的子用户数
   *
   * @generated from field: int32 active = 2;
   */
  active: number;

  /**
   * 禁用的子用户数
   *
   * @generated from field: int32 inactive = 3;
   */
  inactive: number;
};

/**
 * Describes the message puppy.proto.v1.DashboardSubUserStats.
 * Use `create(DashboardSubUserStatsSchema)` to create a new message.
 */
export const DashboardSubUserStatsSchema: GenMessage<DashboardSubUserStats> = /*@__PURE__*/
  messageDesc(file_user, 16);

/**
 * 刷新令牌请求
 *
 * @generated from message puppy.proto.v1.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"puppy.proto.v1.RefreshTokenRequest"> & {
};

/**
 * Describes the message puppy.proto.v1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_user, 17);

/**
 * 刷新令牌响应
 *
 * @generated from message puppy.proto.v1.RefreshTokenResponse
 */
export type RefreshTokenResponse = Message<"puppy.proto.v1.RefreshTokenResponse"> & {
  /**
   * 新的访问令牌
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;
};

/**
 * Describes the message puppy.proto.v1.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema: GenMessage<RefreshTokenResponse> = /*@__PURE__*/
  messageDesc(file_user, 18);

/**
 * 启用2FA请求
 *
 * @generated from message puppy.proto.v1.Enable2FARequest
 */
export type Enable2FARequest = Message<"puppy.proto.v1.Enable2FARequest"> & {
  /**
   * 当前密码（用于二次确认）
   *
   * @generated from field: string password = 1;
   */
  password: string;
};

/**
 * Describes the message puppy.proto.v1.Enable2FARequest.
 * Use `create(Enable2FARequestSchema)` to create a new message.
 */
export const Enable2FARequestSchema: GenMessage<Enable2FARequest> = /*@__PURE__*/
  messageDesc(file_user, 19);

/**
 * 启用2FA响应
 *
 * @generated from message puppy.proto.v1.Enable2FAResponse
 */
export type Enable2FAResponse = Message<"puppy.proto.v1.Enable2FAResponse"> & {
  /**
   * 供扫码的二维码内容（URL 或 data-url，具体以服务端实现为准）
   *
   * @generated from field: string qr_code_url = 1;
   */
  qrCodeUrl: string;

  /**
   * 2FA 密钥（TOTP secret）
   *
   * @generated from field: string secret = 2;
   */
  secret: string;

  /**
   * 2FA 备用代码
   *
   * @generated from field: repeated string backup_codes = 3;
   */
  backupCodes: string[];
};

/**
 * Describes the message puppy.proto.v1.Enable2FAResponse.
 * Use `create(Enable2FAResponseSchema)` to create a new message.
 */
export const Enable2FAResponseSchema: GenMessage<Enable2FAResponse> = /*@__PURE__*/
  messageDesc(file_user, 20);

/**
 * 验证2FA设置请求
 *
 * @generated from message puppy.proto.v1.Verify2FASetupRequest
 */
export type Verify2FASetupRequest = Message<"puppy.proto.v1.Verify2FASetupRequest"> & {
  /**
   * TOTP 验证码
   *
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message puppy.proto.v1.Verify2FASetupRequest.
 * Use `create(Verify2FASetupRequestSchema)` to create a new message.
 */
export const Verify2FASetupRequestSchema: GenMessage<Verify2FASetupRequest> = /*@__PURE__*/
  messageDesc(file_user, 21);

/**
 * 禁用2FA请求
 *
 * @generated from message puppy.proto.v1.Disable2FARequest
 */
export type Disable2FARequest = Message<"puppy.proto.v1.Disable2FARequest"> & {
  /**
   * 当前密码
   *
   * @generated from field: string password = 1;
   */
  password: string;

  /**
   * TOTP / 备用码（用于确认）
   *
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message puppy.proto.v1.Disable2FARequest.
 * Use `create(Disable2FARequestSchema)` to create a new message.
 */
export const Disable2FARequestSchema: GenMessage<Disable2FARequest> = /*@__PURE__*/
  messageDesc(file_user, 22);

/**
 * 生成2FA备用代码响应
 *
 * @generated from message puppy.proto.v1.Generate2FABackupCodesResponse
 */
export type Generate2FABackupCodesResponse = Message<"puppy.proto.v1.Generate2FABackupCodesResponse"> & {
  /**
   * 新生成的一组备用代码
   *
   * @generated from field: repeated string backup_codes = 1;
   */
  backupCodes: string[];
};

/**
 * Describes the message puppy.proto.v1.Generate2FABackupCodesResponse.
 * Use `create(Generate2FABackupCodesResponseSchema)` to create a new message.
 */
export const Generate2FABackupCodesResponseSchema: GenMessage<Generate2FABackupCodesResponse> = /*@__PURE__*/
  messageDesc(file_user, 23);

/**
 * 验证2FA请求
 *
 * @generated from message puppy.proto.v1.Verify2FARequest
 */
export type Verify2FARequest = Message<"puppy.proto.v1.Verify2FARequest"> & {
  /**
   * 需要 2FA 时登录接口返回的临时 access_token
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * TOTP / 备用码
   *
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message puppy.proto.v1.Verify2FARequest.
 * Use `create(Verify2FARequestSchema)` to create a new message.
 */
export const Verify2FARequestSchema: GenMessage<Verify2FARequest> = /*@__PURE__*/
  messageDesc(file_user, 24);

/**
 * 用户服务
 *
 * @generated from service puppy.proto.v1.UserService
 */
export const UserService: GenService<{
  /**
   * 用户注册
   *
   * @generated from rpc puppy.proto.v1.UserService.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 用户登录并吊销旧的所有令牌（实时生效）
   * 同时支持子用户登录：当 tenant_id 非空时，按子用户登录逻辑处理。
   *
   * @generated from rpc puppy.proto.v1.UserService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * 用户登出并吊销所有令牌（实时生效）
   *
   * @generated from rpc puppy.proto.v1.UserService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * 找回密码
   *
   * @generated from rpc puppy.proto.v1.UserService.ResetPassword
   */
  resetPassword: {
    methodKind: "unary";
    input: typeof ResetPasswordRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 获取验证码
   *
   * @generated from rpc puppy.proto.v1.UserService.GetVerificationCode
   */
  getVerificationCode: {
    methodKind: "unary";
    input: typeof GetVerificationCodeRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 获取当前用户信息
   *
   * @generated from rpc puppy.proto.v1.UserService.GetProfile
   */
  getProfile: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof UserSchema;
  },
  /**
   * 修改当前用户显示名
   *
   * @generated from rpc puppy.proto.v1.UserService.UpdateDisplayName
   */
  updateDisplayName: {
    methodKind: "unary";
    input: typeof UpdateDisplayNameRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 修改密码
   *
   * @generated from rpc puppy.proto.v1.UserService.ChangePassword
   */
  changePassword: {
    methodKind: "unary";
    input: typeof ChangePasswordRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 绑定邮箱
   *
   * @generated from rpc puppy.proto.v1.UserService.BindEmail
   */
  bindEmail: {
    methodKind: "unary";
    input: typeof BindEmailRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 绑定手机
   *
   * @generated from rpc puppy.proto.v1.UserService.BindPhone
   */
  bindPhone: {
    methodKind: "unary";
    input: typeof BindPhoneRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 获取用户配额信息
   *
   * @generated from rpc puppy.proto.v1.UserService.GetQuota
   */
  getQuota: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof QuotaInfoSchema;
  },
  /**
   * 获取用户仪表盘数据（用于首页概览等）
   * 说明：主用户会返回 sub_users 统计；子用户该字段为空。
   *
   * @generated from rpc puppy.proto.v1.UserService.GetDashboard
   */
  getDashboard: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof UserDashboardSchema;
  },
  /**
   * 刷新访问令牌（吊销的令牌有 10s 窗口期）
   * 支持 Lax 同源策略的 GET 请求
   *
   * @generated from rpc puppy.proto.v1.UserService.RefreshTokens
   */
  refreshTokens: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof RefreshTokenResponseSchema;
  },
  /**
   * 启用2FA
   *
   * @generated from rpc puppy.proto.v1.UserService.Enable2FA
   */
  enable2FA: {
    methodKind: "unary";
    input: typeof Enable2FARequestSchema;
    output: typeof Enable2FAResponseSchema;
  },
  /**
   * 验证并确认2FA设置
   *
   * @generated from rpc puppy.proto.v1.UserService.Verify2FASetup
   */
  verify2FASetup: {
    methodKind: "unary";
    input: typeof Verify2FASetupRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 禁用2FA
   *
   * @generated from rpc puppy.proto.v1.UserService.Disable2FA
   */
  disable2FA: {
    methodKind: "unary";
    input: typeof Disable2FARequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 生成新的2FA备用代码
   *
   * @generated from rpc puppy.proto.v1.UserService.Generate2FABackupCodes
   */
  generate2FABackupCodes: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof Generate2FABackupCodesResponseSchema;
  },
  /**
   * 验证2FA代码
   *
   * @generated from rpc puppy.proto.v1.UserService.Verify2FA
   */
  verify2FA: {
    methodKind: "unary";
    input: typeof Verify2FARequestSchema;
    output: typeof LoginResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_user, 0);

